import React, { useRef, useState } from "react";
import { Button, Container } from "reactstrap";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../App";
import { toast } from "react-toastify";

function GetInTouch() {
  const formRef = useRef();

  const emailRegExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const nameRegExp = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

  const [formInput, setFormInput] = useState({
    email: "",
    message: "",
    name: "",
  });

  const [error, setError] = useState({});

  const validation = (e) => {
    const msg = {};

    if (formInput.name.trim() === "") {
      msg.name = "Name is requied!";
    } else if (!formInput.name.match(nameRegExp)) {
      msg.name = "Name is valid. Not number!";
    }

    if (formInput.email.trim() === "") {
      msg.email = "Email is requied!";
    } else if (!formInput.email.match(emailRegExp)) {
      msg.email = "Email is valid!";
    }

    if (formInput.message.trim() === "") {
      msg.message = "Message is requied!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const handleOnchangeFormInput = (e) => {
    const { name, value } = e.target;
    setFormInput({ ...formInput, [name]: value });
  };

  const onsubmit = async (e) => {
    e.preventDefault();
    const isValid = validation();

    if (isValid) {
      const docRef = await addDoc(collection(db, "email"), {
        ...formInput,
      });

      toast.success("Send mail success!");

      setFormInput({
        name: "",
        email: "",
        message: "",
      });
    }
  };

  return (
    <Container>
      <div className="py-5 d-flex justify-content-between align-items-center">
        <div className="w-60 me-5">
          <div class="mapouter">
            <div class="gmap_canvas">
              <iframe
                class="gmap_iframe"
                width="100%"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=97 man thiện&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="w-40">
          <form className="get_in_touch" ref={formRef} onSubmit={onsubmit}>
            <p className="fs-3 fw-bold text-center">Get In Touch</p>

            <div className="mt-4 border_input">
              <input
                name="email"
                type="email"
                placeholder="Email"
                className="border-0 w-100"
                value={formInput.email}
                onKeyUp={handleKeyUp}
                onChange={handleOnchangeFormInput}
              />
            </div>

            {error.email && <p className="error">{error.email}</p>}

            <div className="mt-3 border_input">
              <input
                name="name"
                type="text"
                placeholder="Name"
                className="border-0 w-100"
                value={formInput.name}
                onKeyUp={handleKeyUp}
                onChange={handleOnchangeFormInput}
              />
            </div>

            {error.name && <p className="error">{error.name}</p>}

            {/* <div className="mt-3 border_input">
                  <input
                    name="title"
                    type="text"
                    placeholder="Title"
                    className="border-0 w-100"
                  />
                </div> */}

            {/* {errors?.title && (
                  <p className="error">{errors.title?.message}</p>
                )} */}

            <div className="mt-3 mb-2 border_input">
              <textarea
                name="message"
                placeholder="Message"
                className="border-0 w-100"
                value={formInput.message}
                onKeyUp={handleKeyUp}
                onChange={handleOnchangeFormInput}
              />
            </div>

            <div className="d-flex justify-content-center">
              <Button className="btn_custom mt-4">Send Message</Button>
            </div>
          </form>
        </div>
      </div>
    </Container>
  );
}

export default GetInTouch;
